var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c("div", { staticClass: "card-booking-link" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "booking-link-data-wrap" }, [
        _c("span", { staticClass: "booking-link-data-title" }, [
          _vm._v("Sent Via")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "booking-link-data-value" }, [
          _vm._v(
            _vm._s(_vm.lead.booking_link.sent_via === "sms" ? "SMS" : "Email")
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "booking-link-data-wrap" }, [
        _c("span", { staticClass: "booking-link-data-title" }, [
          _vm._v("Sent At")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "booking-link-data-value" }, [
          _vm._v(_vm._s(_vm.lead.booking_link.sent_at))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "booking-link-data-wrap" }, [
        _c("span", { staticClass: "booking-link-data-title" }, [
          _vm._v("Used At")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "booking-link-data-value" }, [
          _vm._v(
            _vm._s(
              _vm.lead.booking_link.used_at
                ? _vm.lead.booking_link.used_at
                : "/"
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "booking-link-data-wrap" }, [
        _c("span", { staticClass: "booking-link-data-title" }, [
          _vm._v("Opened At")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "booking-link-data-value" }, [
          _vm._v(
            _vm._s(
              _vm.lead.booking_link.opened_at
                ? _vm.lead.booking_link.opened_at
                : "/"
            )
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "booking-link-data-wrap" }, [
      _c("h5", { staticClass: "booking-link-title" }, [
        _vm._v("Booking link sent!")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f967519a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f967519a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/BookingLinkSent.vue
// module id = null
// module chunks = 